import moreContentHorizontalIcon from '../../../assets/images/svg/more-content-horizontal-icon';

import { parseHRef, getClosesAnchor } from './utilities';

// define ONCE at module scope
export const EMAIL_TAG = 'v-email';

if (!customElements.get(EMAIL_TAG)) {
  const SHEET = new CSSStyleSheet();
  SHEET.replaceSync(`
    :host{display:block}
    div, html { height:auto }
    .minimized-toggle-button{
      width:30px;height:15px;box-sizing:border-box;border:unset;background:unset;cursor:pointer;
      border-radius:var(--application-border-radius);border:1px solid transparent;
      transition:border-color var(--application-transition-duration) var(--application-transition-function);padding:0
    }
    .minimized-toggle-button:hover { border-color: var(--startup-tertiary-color) }
    .minimized-toggle-button svg{width:100%;height:100%}
    .minimized-toggle-button svg path{
      stroke:var(--startup-tertiary-color);
      transition:stroke var(--application-transition-duration) var(--application-transition-function)
    }
    .minimized-toggle-button:hover path{ stroke:var(--startup-tertiary-color) }

    .editor-element.table-wrapper table {
      width: max-content;
      border-collapse: separate;
    }
.editor-element.table-wrapper table.table-layout {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.editor-element.table-wrapper table.table-layout td,
.editor-element.table-wrapper table.table-layout th {
  border: 1px solid #d0d7de;
  padding: 8px 10px;

  height: auto;
  min-height: 0;

  white-space: normal;
  overflow: visible;
  overflow-wrap: normal;
  word-break: normal;

  vertical-align: top;
  line-height: 1.35;
}

.editor-element.table-wrapper table.table-layout th {
  font-weight: 600;
}.url-embed-data {
    flex-direction: row !important;
}.url-embed-data-image-details {
max-height: 100px;
max-width: 100px;
}
  `);
  class VEmail extends HTMLElement {
    constructor() {
      super();
      this._html = ''; // cached payload
      this.minimized = true;
      this.emailQuoteElements = [];
      this.minimizedToggleButton = null;

      this.div = document.createElement('div');
      this.div.style.overflowWrap = 'anywhere';
      const sr = this.attachShadow({ mode: 'open' });
      sr.adoptedStyleSheets = [SHEET]; // your constructable sheet
      sr.append(this.div);

      // bind once; (re)attach in connectedCallback for cleanliness
      this._onClick = this.handleClick.bind(this);
    }

    // feed HTML after construction; avoids outer-scope capture
    set contentHTML(h) {
      this.div.innerHTML = h || '';
      this.tryMinimizeEmailQuote();
    }

    // accept callback via property; set null to remove
    set onEmailClick(fn) {
      this._onEmailClick = (typeof fn === 'function') ? fn : null;
    }

    set contentHTML(h) {
      this._html = h || '';
      if (this.isConnected) this._render();
    }
    _render() {
      this.div.innerHTML = this._html;
      this.tryMinimizeEmailQuote();
    }

    connectedCallback() {
      this.div.addEventListener('click', this._onClick, { passive: false });
      if (this._html) this._render();
    }

    // automatic cleanup when node leaves DOM
    disconnectedCallback() {
      this.destroy();
    }

    hideEmailQuote = () => { this.emailQuoteElements.forEach(el => { el.style.display = 'none'; }); };
    showEmailQuote = () => { this.emailQuoteElements.forEach(el => { el.style.display = 'block'; }); };

    toggleMinimized = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.minimized) {
        this.minimized = false;
        this.showEmailQuote();
      } else {
        this.minimized = true;
        this.hideEmailQuote();
      }
    };

    addMinimizedToggleButtonForPlatform = (emailQuote) => {
      this.emailQuoteElements = Array.from(emailQuote.children);
      this.hideEmailQuote();
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'minimized-toggle-button';
      btn.onclick = this.toggleMinimized;
      btn.appendChild(moreContentHorizontalIcon.cloneNode(true));
      emailQuote.prepend(btn);
      this.minimizedToggleButton = btn;
    };

    addMinimizedToggleButtonForGmail = (q) => this.addMinimizedToggleButtonForPlatform(q);
    addMinimizedToggleButtonForYahoo = (q) => this.addMinimizedToggleButtonForPlatform(q);

    addMinimizedToggleButtonForMicrosoft = (separator) => {
      const appended = [];
      while (separator?.nextElementSibling) {
        appended.push(separator.nextElementSibling);
        separator.nextElementSibling.remove();
      }
      const container = document.createElement('div');
      container.className = 'ms-email-appended-content';
      appended.forEach(n => container.appendChild(n));
      separator.after(container);

      this.emailQuoteElements = appended;
      this.hideEmailQuote();

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'minimized-toggle-button';
      btn.onclick = this.toggleMinimized;
      btn.appendChild(moreContentHorizontalIcon.cloneNode(true));
      container.prepend(btn);
    };

    addMinimizedToggleButtonForOutlook = (sep) => {
      const last = sep.previousElementSibling;
      if (last) this.addMinimizedToggleButtonForMicrosoft(last);
    };

    isVenturzEmail = () => this.div.querySelector(':scope > .editor-element-wrapper') !== null;

    removeMinimizedToggleButton = () => {
      this.minimizedToggleButton?.parentNode?.removeChild(this.minimizedToggleButton);
      this.minimizedToggleButton = null;
    };

    tryMinimizeEmailQuote = () => {
      const root = this.div;

      const emailQuote = root.querySelector('.email-quote');
      if (this.isVenturzEmail() && emailQuote) return this.addMinimizedToggleButtonForPlatform(emailQuote);

      const gmailQuote = root.querySelector('div.gmail_quote');
      if (gmailQuote) return this.addMinimizedToggleButtonForGmail(gmailQuote);

      const yahooQuote = root.querySelector('div.yahoo_quoted');
      if (yahooQuote) return this.addMinimizedToggleButtonForYahoo(yahooQuote);

      const msQuote = root.querySelector('div#appendonsend');
      if (msQuote) return this.addMinimizedToggleButtonForMicrosoft(msQuote);

      const outlookHeader = root.querySelector('div.OutlookMessageHeader');
      if (outlookHeader) return this.addMinimizedToggleButtonForOutlook(outlookHeader);

      const moz = root.querySelector('div.moz-cite-prefix');
      if (moz) return this.addMinimizedToggleButtonForOutlook(moz);

      const apple = root.querySelector('blockquote[type=cite]');
      if (apple) return this.addMinimizedToggleButtonForPlatform(apple);

      const def = root.querySelector(':scope > blockquote');
      if (def) return this.addMinimizedToggleButtonForOutlook(def);
    };

    handleClick = (event) => {
      const a = event.target.closest('a[href]');
      if (!a) return;

      const href = a.getAttribute('href');
      const result = parseHRef(href);
      event.linkTarget = a;
      if (result.type === 'email-link') {
        event.preventDefault();
        // prefer user callback if provided; fall back to existing emitter
        if (this._onEmailClick) {
          this._onEmailClick({ emailAddress: result.value, anchor: a, event });
        } else {
          eventSystem.internal.emit(internalEventCodes.EMAIL_LINK_CLICKED, { emailAddress: result.value });
        }
      }
    };

    serializeForEmail() {
      const clone = this.div.cloneNode(true);

      const toggleButton = clone.querySelector('.minimized-toggle-button');
      if (toggleButton !== null) {
        toggleButton.remove();
      }

      const hiddenElements = clone.querySelectorAll('[style*="display: none"], [style*="display:none"]');
      hiddenElements.forEach(element => {
        element.style.display = 'block';
      });

      const dataImages = clone.querySelectorAll('img[src^="data:"]');
      dataImages.forEach(img => {
        img.remove();
      });

      return clone.innerHTML;
    }

    // explicit teardown to help GC in virtualized lists
    destroy() {
      this.removeMinimizedToggleButton();
      this.emailQuoteElements = [];
      this.div.replaceChildren(); // drop big strings
      this.div.removeEventListener('click', this._onClick);
    }
  }

  customElements.define(EMAIL_TAG, VEmail);
}

// usage:
// const node = document.createElement(EMAIL_TAG);
// node.onEmailClick = ({ emailAddress }) => { /* handle */ };
// node.contentHTML = html;
